// The horizontal lockup, inline as markup (a web font inside an <img>
// would not load — the server's brand package says the same). The asset
// is the same file the server serves its pages from; its background
// rect is painted out so it sits on the app's ground, which is not flat.
import type { JSX } from "solid-js";
import lockupRaw from "@/assets/lockup-horizontal.svg?raw";

const lockupDark = "#1f262b";

// Markup, transformed exactly as server/internal/brand does: the class
// and the label in, the baked dark out. A string pattern replaces the
// first occurrence only, which is the one.
const markup = lockupRaw
  .replace("<svg ", '<svg class="lockup" role="img" aria-label="Psypen" ')
  .replace(`fill="${lockupDark}"`, 'fill="none"');

export function Lockup(): JSX.Element {
  // The app's own bundled asset, not user input; the markup is ours down
  // to the byte the same way the server's pages inline it.
  // eslint-disable-next-line solid/no-innerhtml
  return <div innerHTML={markup} />;
}
